import { useEffect } from 'react'

interface HotkeyConfig {
  key: string
  ctrl?: boolean
  meta?: boolean
  shift?: boolean
  alt?: boolean
  callback: () => void
  enabled?: boolean
}

export function useHotkeys(config: HotkeyConfig | HotkeyConfig[]) {
  useEffect(() => {
    const configs = Array.isArray(config) ? config : [config]
    
    const handler = (e: KeyboardEvent) => {
      for (const hotkey of configs) {
        if (hotkey.enabled === false) continue
        
        const keyMatch = e.key.toLowerCase() === hotkey.key.toLowerCase()
        const ctrlMatch = hotkey.ctrl ? (e.ctrlKey || e.metaKey) : true
        const metaMatch = hotkey.meta ? e.metaKey : true
        const shiftMatch = hotkey.shift ? e.shiftKey : true
        const altMatch = hotkey.alt ? e.altKey : true
        
        if (keyMatch && ctrlMatch && metaMatch && shiftMatch && altMatch) {
          e.preventDefault()
          hotkey.callback()
          break
        }
      }
    }
    
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [config])
}